var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18.002,
  viewBox: "0 0 18 18.002"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3579",
  "data-name": "Group 3579",
  transform: "translate(-2.977 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M19.622,6.51A3.823,3.823,0,0,0,15.777,3H8A3.8,3.8,0,0,0,4.242,6.51L2.99,16.771a4,4,0,0,0,.984,2.97A3.846,3.846,0,0,0,6.835,21H17.118a3.852,3.852,0,0,0,3.845-4.23Z",
  transform: "translate(0 0)",
  fill: "#4465d1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M15.384,14.051a5.089,5.089,0,0,1-5.034-5.1.987.987,0,1,1,1.974,0,3.06,3.06,0,1,0,6.12,0,.987.987,0,1,1,1.974,0A5.089,5.089,0,0,1,15.384,14.051Z",
  transform: "translate(-3.447 -2.599)",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/packaging.f6b733a5.svg";
export { SvgComponent as ReactComponent };